export const OpenMail = () => {
  return (
    <i>
      <svg
        width="25"
        height="25"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2116_10)">
          <path
            d="M24.7863 23.8146L35.6563 34.6813C35.2206 35.2596 34.6643 35.7363 34.0259 36.0782C33.3876 36.4201 32.6826 36.619 31.9597 36.6613L31.6663 36.6696H8.33301C7.55962 36.6705 6.79662 36.4916 6.10419 36.1471C5.41176 35.8026 4.80885 35.302 4.34301 34.6846L15.2113 23.8146L19.0747 26.3896L19.268 26.4996C19.4958 26.6109 19.7461 26.6688 19.9997 26.6688C20.2533 26.6688 20.5035 26.6109 20.7313 26.4996L20.9247 26.3896L24.7863 23.8146ZM3.33301 15.8946L12.3813 21.9279L3.33301 30.9779V15.8946ZM36.6663 15.8946V30.9779L27.6163 21.9279L36.6663 15.8946ZM20.733 3.50628L20.9247 3.61628L34.998 12.9979L19.9997 22.9979L4.99967 12.9979L19.0747 3.61462C19.3173 3.45336 19.5979 3.3585 19.8886 3.33949C20.1792 3.32048 20.4715 3.37799 20.733 3.50628Z"
            fill="#E1EEDD"
          />
        </g>
        <defs>
          <clipPath id="clip0_2116_10">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </i>
  );
};

export const Heart = () => {
  return (
    <i>
      <svg
        width="25"
        height="25"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1986_633)">
          <path
            d="M15.83 9.65522C18.1967 6.48188 21.755 5.55522 25.0283 6.44688C28.5617 7.40855 31.6683 10.4436 32.7 14.6702C32.7533 14.8869 32.8 15.1036 32.8383 15.3202C31.349 14.7899 29.7292 14.749 28.215 15.2036C26.07 13.6169 23.4133 13.3502 21.0517 14.2202C18.0933 15.3119 15.7833 18.0802 15.2483 21.5635C14.565 26.0236 17.2817 30.0302 21.1233 33.4369L21.77 33.9969C21.2483 34.0336 20.7183 33.9519 20.2117 33.8435C19.9513 33.7879 19.6923 33.7256 19.435 33.6569L18.54 33.4069C10.5833 31.1686 5.25667 27.6669 3.72834 22.4335C2.50834 18.2569 3.68167 14.0752 6.26167 11.4752C8.65167 9.06688 12.195 8.09022 15.83 9.65522ZM18.5433 22.0686C19.2567 17.4152 24.6383 15.1219 27.4017 19.1152C27.4282 19.1523 27.4682 19.1775 27.5131 19.1853C27.558 19.1931 27.6042 19.1829 27.6417 19.1569C31.6033 16.3502 35.875 20.3452 34.9533 24.9619C34.42 27.6385 31.9367 29.8619 27.5033 31.6285L26.7783 31.9119L26.34 32.0919C25.9617 32.2402 25.5617 32.3586 25.2 32.2952C24.84 32.2319 24.505 31.9819 24.2 31.7152L23.6833 31.2486C19.8283 27.9302 18.115 24.8702 18.5433 22.0686Z"
            fill="#E1EEDD"
          />
        </g>
        <defs>
          <clipPath id="clip0_1986_633">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </i>
  );
};

export const Calender = () => {
  return (
    <i>
      <svg
        width="25"
        height="25"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.33301 31.6693C3.33301 34.5026 5.49967 36.6693 8.33301 36.6693H31.6663C34.4997 36.6693 36.6663 34.5026 36.6663 31.6693V18.3359H3.33301V31.6693ZM31.6663 6.66927H28.333V5.0026C28.333 4.0026 27.6663 3.33594 26.6663 3.33594C25.6663 3.33594 24.9997 4.0026 24.9997 5.0026V6.66927H14.9997V5.0026C14.9997 4.0026 14.333 3.33594 13.333 3.33594C12.333 3.33594 11.6663 4.0026 11.6663 5.0026V6.66927H8.33301C5.49967 6.66927 3.33301 8.83594 3.33301 11.6693V15.0026H36.6663V11.6693C36.6663 8.83594 34.4997 6.66927 31.6663 6.66927Z"
          fill="#E1EEDD"
        />
      </svg>
    </i>
  );
};
export const Camera = () => {
  return (
    <i>
      <svg
        width="25"
        height="25"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1986_643)">
          <path
            d="M5.33301 2.66406H18.6663V5.33073H5.33301V2.66406ZM21.333 22.6641C21.333 21.6032 21.7544 20.5858 22.5046 19.8356C23.2547 19.0855 24.2721 18.6641 25.333 18.6641C26.3939 18.6641 27.4113 19.0855 28.1614 19.8356C28.9116 20.5858 29.333 21.6032 29.333 22.6641C29.333 23.7249 28.9116 24.7423 28.1614 25.4925C27.4113 26.2426 26.3939 26.6641 25.333 26.6641C24.2721 26.6641 23.2547 26.2426 22.5046 25.4925C21.7544 24.7423 21.333 23.7249 21.333 22.6641Z"
            fill="#E1EEDD"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 33.3333C0 34.3942 0.421427 35.4116 1.17157 36.1618C1.92172 36.9119 2.93913 37.3333 4 37.3333H36C37.0609 37.3333 38.0783 36.9119 38.8284 36.1618C39.5786 35.4116 40 34.3942 40 33.3333V12C40 10.9391 39.5786 9.92172 38.8284 9.17157C38.0783 8.42143 37.0609 8 36 8H4C2.93913 8 1.92172 8.42143 1.17157 9.17157C0.421427 9.92172 0 10.9391 0 12L0 33.3333ZM25.3333 16C23.5652 16 21.8695 16.7024 20.6193 17.9526C19.369 19.2029 18.6667 20.8986 18.6667 22.6667C18.6667 24.4348 19.369 26.1305 20.6193 27.3807C21.8695 28.631 23.5652 29.3333 25.3333 29.3333C27.1014 29.3333 28.7971 28.631 30.0474 27.3807C31.2976 26.1305 32 24.4348 32 22.6667C32 20.8986 31.2976 19.2029 30.0474 17.9526C28.7971 16.7024 27.1014 16 25.3333 16Z"
            fill="#E1EEDD"
          />
        </g>
        <defs>
          <clipPath id="clip0_1986_643">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </i>
  );
};
export const History = () => {
  return (
    <i>
      <svg
        width="25"
        height="25"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.333 5.5026C21.833 1.83594 13.833 3.0026 8.49967 8.0026V5.0026C8.49967 4.0026 7.83301 3.33594 6.83301 3.33594C5.83301 3.33594 5.16634 4.0026 5.16634 5.0026V12.5026C5.16634 13.5026 5.83301 14.1693 6.83301 14.1693H14.333C15.333 14.1693 15.9997 13.5026 15.9997 12.5026C15.9997 11.5026 15.333 10.8359 14.333 10.8359H10.333C12.833 8.16927 16.333 6.66927 19.9997 6.66927C27.333 6.66927 33.333 12.6693 33.333 20.0026C33.333 27.3359 27.333 33.3359 19.9997 33.3359C12.6663 33.3359 6.66634 27.3359 6.66634 20.0026C6.66634 19.0026 5.99967 18.3359 4.99967 18.3359C3.99967 18.3359 3.33301 19.0026 3.33301 20.0026C3.33301 29.1693 10.833 36.6693 19.9997 36.6693C25.9997 36.6693 31.4997 33.5026 34.4997 28.3359C38.9997 20.3359 36.333 10.1693 28.333 5.5026ZM19.9997 13.3359C18.9997 13.3359 18.333 14.0026 18.333 15.0026V20.0026C18.333 21.0026 18.9997 21.6693 19.9997 21.6693H23.333C24.333 21.6693 24.9997 21.0026 24.9997 20.0026C24.9997 19.0026 24.333 18.3359 23.333 18.3359H21.6663V15.0026C21.6663 14.0026 20.9997 13.3359 19.9997 13.3359Z"
          fill="#E1EEDD"
        />
      </svg>
    </i>
  );
};
export const Gift = () => {
  return (
    <i>
      <svg
        width="25"
        height="25"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1986_652)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1.32893e-06C10.2319 1.32893e-06 8.5362 0.70238 7.28595 1.95262C6.03571 3.20287 5.33333 4.89856 5.33333 6.66667V7.42933C5.33333 8.624 5.688 9.736 6.29867 10.6667H4C2.93913 10.6667 1.92172 11.0881 1.17157 11.8382C0.421427 12.5884 0 13.6058 0 14.6667L0 17.3333C0 18.3942 0.421427 19.4116 1.17157 20.1618C1.92172 20.9119 2.93913 21.3333 4 21.3333H18.6667V10.6667H21.3333V21.3333H36C37.0609 21.3333 38.0783 20.9119 38.8284 20.1618C39.5786 19.4116 40 18.3942 40 17.3333V14.6667C40 13.6058 39.5786 12.5884 38.8284 11.8382C38.0783 11.0881 37.0609 10.6667 36 10.6667H33.7013C34.312 9.736 34.6667 8.624 34.6667 7.42933V6.66667C34.6667 4.89856 33.9643 3.20287 32.714 1.95262C31.4638 0.70238 29.7681 1.32893e-06 28 1.32893e-06C24.6053 1.32893e-06 21.632 1.81333 20 4.52267C19.1704 3.14236 17.9975 2.00035 16.5956 1.20779C15.1937 0.415239 13.6104 -0.000858195 12 1.32893e-06ZM21.3333 10.6667H28.7627C30.5493 10.6667 32 9.216 32 7.42933V6.66667C32 5.6058 31.5786 4.58839 30.8284 3.83824C30.0783 3.0881 29.0609 2.66667 28 2.66667C26.2319 2.66667 24.5362 3.36905 23.286 4.61929C22.0357 5.86953 21.3333 7.56522 21.3333 9.33333V10.6667ZM18.6667 10.6667H11.2373C9.45067 10.6667 8 9.216 8 7.42933V6.66667C8 5.6058 8.42143 4.58839 9.17157 3.83824C9.92172 3.0881 10.9391 2.66667 12 2.66667C12.8755 2.66667 13.7424 2.83911 14.5512 3.17414C15.3601 3.50917 16.095 4.00023 16.714 4.61929C17.3331 5.23835 17.8242 5.97327 18.1592 6.78211C18.4942 7.59095 18.6667 8.45786 18.6667 9.33333V10.6667Z"
            fill="#E1EEDD"
          />
          <path
            d="M18.667 24H2.66699V33.3333C2.66699 35.1014 3.36937 36.7971 4.61961 38.0474C5.86986 39.2976 7.56555 40 9.33366 40H18.667V24ZM21.3337 40H30.667C32.4351 40 34.1308 39.2976 35.381 38.0474C36.6313 36.7971 37.3337 35.1014 37.3337 33.3333V24H21.3337V40Z"
            fill="#E1EEDD"
          />
        </g>
        <defs>
          <clipPath id="clip0_1986_652">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </i>
  );
};
export const Ring = () => {
  return (
    <i>
      <svg
        width="35"
        height="44"
        viewBox="0 0 35 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.1639 10.268L24.0589 5.641C24.2659 5.396 24.3407 5.068 24.2629 4.758L23.2528 0.758C23.1407 0.312 22.7366 0 22.273 0H12.172C11.7084 0 11.3043 0.312 11.1922 0.758L10.1821 4.758C10.1043 5.068 10.1801 5.396 10.3861 5.641L14.2821 10.268C6.2124 11.655 0.0507812 18.62 0.0507812 27C0.0507812 36.374 7.75381 44 17.2225 44C26.6912 44 34.3942 36.374 34.3942 27C34.3942 18.62 28.2336 11.655 20.1639 10.268ZM18.2326 6H19.2427C19.8003 6 20.2528 5.553 20.2528 5C20.2528 4.447 19.8003 4 19.2427 4H18.2326V2H21.4841L22.1791 4.75L18.2326 9.438V6ZM12.9609 2H16.2124V4H12.4558L12.9609 2ZM16.2124 6V9.437L13.3185 6H16.2124ZM17.2225 42C8.86795 42 2.07098 35.271 2.07098 27C2.07098 18.729 8.86795 12 17.2225 12C25.577 12 32.374 18.729 32.374 27C32.374 35.271 25.577 42 17.2225 42Z"
          fill="#FEFBE9"
        />
        <path
          d="M17.2221 14C9.98173 14 4.09082 19.832 4.09082 27C4.09082 34.168 9.98173 40 17.2221 40C24.4625 40 30.3534 34.168 30.3534 27C30.3534 19.832 24.4625 14 17.2221 14ZM17.2221 38C11.0959 38 6.11102 33.065 6.11102 27C6.11102 20.935 11.0959 16 17.2221 16C23.3484 16 28.3332 20.935 28.3332 27C28.3332 33.065 23.3484 38 17.2221 38Z"
          fill="#FEFBE9"
        />
        <path
          d="M32.3744 6H29.3441C28.7865 6 28.334 5.553 28.334 5C28.334 4.447 28.7865 4 29.3441 4H32.3744C32.932 4 33.3845 4.447 33.3845 5C33.3845 5.553 32.932 6 32.3744 6Z"
          fill="#FEFBE9"
        />
        <path
          d="M29.344 10.0002C29.0854 10.0002 28.8269 9.90225 28.6299 9.70725L26.6097 7.70725C26.2147 7.31625 26.2147 6.68425 26.6097 6.29325C27.0046 5.90225 27.643 5.90225 28.038 6.29325L30.0582 8.29325C30.4531 8.68425 30.4531 9.31625 30.0582 9.70725C29.8612 9.90225 29.6026 10.0002 29.344 10.0002Z"
          fill="#FEFBE9"
        />
        <path
          d="M27.3238 4.00025C27.0652 4.00025 26.8067 3.90225 26.6097 3.70725C26.2147 3.31625 26.2147 2.68425 26.6097 2.29325L28.6299 0.29325C29.0248 -0.09775 29.6632 -0.09775 30.0582 0.29325C30.4531 0.68425 30.4531 1.31625 30.0582 1.70725L28.038 3.70725C27.841 3.90225 27.5824 4.00025 27.3238 4.00025Z"
          fill="#FEFBE9"
        />
        <path
          d="M5.10095 6H2.07065C1.51307 6 1.06055 5.553 1.06055 5C1.06055 4.447 1.51307 4 2.07065 4H5.10095C5.65853 4 6.11105 4.447 6.11105 5C6.11105 5.553 5.65853 6 5.10095 6Z"
          fill="#FEFBE9"
        />
        <path
          d="M7.12138 4.00025C6.86279 4.00025 6.6042 3.90225 6.40723 3.70725L4.38703 1.70725C3.99208 1.31625 3.99208 0.68425 4.38703 0.29325C4.78198 -0.09775 5.42037 -0.09775 5.81531 0.29325L7.83552 2.29325C8.23047 2.68425 8.23047 3.31625 7.83552 3.70725C7.63855 3.90225 7.37996 4.00025 7.12138 4.00025Z"
          fill="#FEFBE9"
        />
        <path
          d="M5.10117 10.0002C4.84259 10.0002 4.584 9.90225 4.38703 9.70725C3.99208 9.31625 3.99208 8.68425 4.38703 8.29325L6.40723 6.29325C6.80218 5.90225 7.44057 5.90225 7.83552 6.29325C8.23047 6.68425 8.23047 7.31625 7.83552 7.70725L5.81531 9.70725C5.61835 9.90225 5.35976 10.0002 5.10117 10.0002Z"
          fill="#FEFBE9"
        />
      </svg>
    </i>
  );
};
export const Bouquet = () => {
  return (
    <i>
      <svg
        width="28"
        height="44"
        viewBox="0 0 28 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23 10C23.5523 10 24 9.55228 24 9C24 8.44772 23.5523 8 23 8C22.4477 8 22 8.44772 22 9C22 9.55228 22.4477 10 23 10Z"
          fill="#FEFBE9"
        />
        <path
          d="M4.99902 10C5.55131 10 5.99902 9.55228 5.99902 9C5.99902 8.44771 5.55131 8 4.99902 8C4.44674 8 3.99902 8.44771 3.99902 9C3.99902 9.55228 4.44674 10 4.99902 10Z"
          fill="#FEFBE9"
        />
        <path
          d="M5 10C5.55228 10 6 9.55228 6 9C6 8.44772 5.55228 8 5 8C4.44772 8 4 8.44772 4 9C4 9.55228 4.44772 10 5 10Z"
          fill="#FEFBE9"
        />
        <path
          d="M14 13C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11C13.4477 11 13 11.4477 13 12C13 12.5523 13.4477 13 14 13Z"
          fill="#FEFBE9"
        />
        <path
          d="M23 10C23.5523 10 24 9.55228 24 9C24 8.44772 23.5523 8 23 8C22.4477 8 22 8.44772 22 9C22 9.55228 22.4477 10 23 10Z"
          fill="#FEFBE9"
        />
        <path
          d="M18 6C18.5523 6 19 5.55228 19 5C19 4.44772 18.5523 4 18 4C17.4477 4 17 4.44772 17 5C17 5.55228 17.4477 6 18 6Z"
          fill="#FEFBE9"
        />
        <path
          d="M10 6C10.5523 6 11 5.55228 11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5C9 5.55228 9.44772 6 10 6Z"
          fill="#FEFBE9"
        />
        <path
          d="M7 17C7.55228 17 8 16.5523 8 16C8 15.4477 7.55228 15 7 15C6.44772 15 6 15.4477 6 16C6 16.5523 6.44772 17 7 17Z"
          fill="#FEFBE9"
        />
        <path
          d="M21 17C21.5523 17 22 16.5523 22 16C22 15.4477 21.5523 15 21 15C20.4477 15 20 15.4477 20 16C20 16.5523 20.4477 17 21 17Z"
          fill="#FEFBE9"
        />
        <path
          d="M27.8495 6.98919C27.5655 6.30419 26.9305 5.84119 26.1925 5.78019C26.1585 5.06819 25.6945 4.43319 25.0095 4.14919C24.3315 3.87019 23.5665 3.98519 23.0005 4.45019C22.9625 4.41919 22.9175 4.40519 22.8775 4.37719C23.0305 3.93119 23.0355 3.44319 22.8485 2.99019C22.5645 2.30519 21.9295 1.84219 21.2175 1.80719C21.1565 1.06919 20.6935 0.434188 20.0085 0.150188C19.3325 -0.128812 18.5645 -0.0138123 18.0005 0.451188C17.4355 -0.0138123 16.6705 -0.128812 15.9915 0.150188C15.3065 0.434188 14.8435 1.06919 14.8085 1.78119C14.5135 1.80519 14.2435 1.90919 13.9975 2.05119C13.7575 1.91719 13.4985 1.82119 13.2185 1.80819C13.1575 1.07019 12.6945 0.435188 12.0095 0.151188C11.3325 -0.128812 10.5645 -0.0138123 10.0005 0.451188C9.43545 -0.0138123 8.67045 -0.128812 7.99145 0.150188C7.30645 0.434188 6.84345 1.06919 6.80845 1.78119C6.07045 1.84219 5.43545 2.30519 5.15145 2.99019C4.96245 3.44619 4.96945 3.93819 5.12545 4.37519C5.08545 4.40419 5.03845 4.41819 5.00045 4.45019C4.43545 3.98519 3.67045 3.87019 2.99145 4.14919C2.30645 4.43319 1.84345 5.06819 1.80845 5.78019C1.07045 5.84119 0.435453 6.30519 0.151453 6.98919C-0.131547 7.67419 -0.0105468 8.45119 0.467453 8.97919C-0.0115468 9.54419 -0.132547 10.3222 0.151453 11.0062C0.435453 11.6912 1.07045 12.1542 1.78245 12.1892C1.82445 12.7072 2.07445 13.1672 2.45145 13.4972C2.33145 13.6442 2.22745 13.8072 2.15245 13.9892C1.86945 14.6742 1.99045 15.4512 2.46845 15.9792C1.98945 16.5442 1.86845 17.3222 2.15245 18.0062C2.33845 18.4552 2.68345 18.7932 3.09345 18.9932C3.37645 21.5662 4.42945 24.0052 6.14945 25.9712L9.80645 30.1512L7.27745 35.2092C7.09645 35.5712 7.00045 35.9772 7.00045 36.3822C7.00045 37.8252 8.17445 38.9992 9.61645 38.9992H10.0005V39.9992C10.0005 40.5522 10.4475 40.9992 11.0005 40.9992C11.5535 40.9992 12.0005 40.5522 12.0005 39.9992V38.9992H13.0005V42.9992C13.0005 43.5522 13.4475 43.9992 14.0005 43.9992C14.5535 43.9992 15.0005 43.5522 15.0005 42.9992V38.9992H16.0005V40.9992C16.0005 41.5522 16.4475 41.9992 17.0005 41.9992C17.5535 41.9992 18.0005 41.5522 18.0005 40.9992V38.9992H18.3845C19.8265 38.9992 21.0005 37.8252 21.0005 36.3822C21.0005 35.9792 20.9045 35.5732 20.7245 35.2122L18.1955 30.1522L21.8525 25.9722C23.5715 24.0072 24.6235 21.5702 24.9075 18.9982C25.3215 18.7902 25.6645 18.4532 25.8495 18.0072C26.1325 17.3222 26.0115 16.5452 25.5335 16.0172C26.0125 15.4522 26.1335 14.6742 25.8495 13.9902C25.7735 13.8082 25.6705 13.6452 25.5505 13.4982C25.9275 13.1672 26.1765 12.7082 26.2195 12.1902C26.9315 12.1562 27.5665 11.6922 27.8505 11.0072C28.1335 10.3222 28.0125 9.54519 27.5345 8.98019C28.0115 8.45119 28.1325 7.67419 27.8495 6.98919ZM14.9815 3.77319C15.9415 3.69019 16.6955 2.93419 16.7275 1.99419C17.4495 2.60419 18.4955 2.61819 19.2305 2.02819C19.3345 2.96619 20.0805 3.69519 21.0045 3.72619C20.3805 4.46319 20.3805 5.53419 21.0255 6.22319C20.0615 6.30319 19.3035 7.06119 19.2715 8.00319C18.5805 7.41919 17.5985 7.38919 16.9075 7.92219C16.8495 7.83119 16.7835 7.74819 16.7115 7.66819C16.4985 6.88019 15.8165 6.29919 14.9945 6.27119C15.6155 5.53719 15.6175 4.47319 14.9805 3.78319C14.9815 3.78019 14.9815 3.77719 14.9815 3.77319ZM24.0265 17.2242C23.0625 17.3042 22.3045 18.0622 22.2725 19.0042C21.5385 18.3822 20.4665 18.3802 19.7755 19.0252C19.6955 18.0612 18.9375 17.3032 17.9955 17.2712C18.6195 16.5342 18.6195 15.4632 17.9745 14.7742C18.9385 14.6942 19.6965 13.9362 19.7285 12.9942C20.4505 13.6052 21.4965 13.6182 22.2315 13.0282C22.3355 13.9662 23.0815 14.6952 24.0055 14.7262C23.3815 15.4642 23.3815 16.5342 24.0265 17.2242ZM15.1045 9.09819C15.1595 9.18319 15.2245 9.25819 15.2925 9.33319C15.5065 10.1192 16.1845 10.6992 17.0065 10.7262C16.4205 11.4192 16.3925 12.4012 16.9255 13.0902C16.8345 13.1482 16.7525 13.2142 16.6715 13.2862C15.8835 13.4992 15.3025 14.1812 15.2745 15.0032C14.5405 14.3812 13.4685 14.3792 12.7775 15.0242C12.7085 14.1942 12.1355 13.5192 11.3755 13.3272C11.2915 13.2472 11.2075 13.1722 11.1115 13.1092C11.6115 12.3832 11.5775 11.4152 10.9765 10.7732C11.8065 10.7042 12.4815 10.1312 12.6735 9.37119C12.7575 9.28319 12.8345 9.19319 12.8995 9.09219C13.5675 9.55319 14.4325 9.55919 15.1045 9.09819ZM8.72845 1.99419C9.45045 2.60419 10.4965 2.61819 11.2315 2.02819C11.3355 2.96619 12.0815 3.69519 13.0055 3.72619C12.3845 4.46019 12.3825 5.52419 13.0195 6.21419C13.0195 6.21819 13.0195 6.22119 13.0195 6.22519C12.0595 6.30819 11.3055 7.06419 11.2735 8.00419C10.5385 7.38219 9.46745 7.38019 8.77645 8.02519C8.69645 7.06119 7.93845 6.30319 6.99645 6.27119C7.62045 5.53419 7.62045 4.46319 6.97545 3.77419C7.93745 3.69419 8.69545 2.93719 8.72845 1.99419ZM3.99545 17.2712C4.61945 16.5342 4.61945 15.4632 3.97445 14.7742C4.93845 14.6942 5.69645 13.9362 5.72845 12.9942C6.45045 13.6052 7.49645 13.6182 8.23145 13.0282C8.33545 13.9662 9.08145 14.6952 10.0055 14.7262C9.38145 15.4632 9.38145 16.5342 10.0265 17.2232C9.06245 17.3032 8.30445 18.0612 8.27245 19.0032C7.53845 18.3812 6.46645 18.3792 5.77545 19.0242C5.69545 18.0612 4.93745 17.3042 3.99545 17.2712ZM1.99545 10.2702C2.61945 9.53319 2.61945 8.46219 1.97445 7.77319C2.93845 7.69319 3.69645 6.93519 3.72845 5.99319C4.10245 6.30919 4.55945 6.43819 5.01645 6.42619C5.03445 6.62319 5.07445 6.81919 5.15245 7.00819C5.43645 7.69319 6.07145 8.15619 6.78345 8.19119C6.83445 8.80819 7.17645 9.33919 7.68445 9.66719C7.76445 9.86719 7.87245 10.0572 8.02745 10.2232C7.37745 10.2772 6.82645 10.6432 6.52345 11.1632C6.04245 10.9562 5.49345 10.9442 4.99245 11.1512C4.68945 11.2772 4.44045 11.4792 4.24245 11.7182C4.07645 11.7962 3.91745 11.8932 3.77645 12.0252C3.69545 11.0602 2.93745 10.3032 1.99545 10.2702ZM18.9355 36.1062C18.9785 36.1912 19.0005 36.2872 19.0005 36.3822C19.0005 36.7222 18.7245 36.9992 18.3845 36.9992H9.61645C9.27645 36.9992 9.00045 36.7222 9.00045 36.3812C9.00045 36.2852 9.02245 36.1902 9.06545 36.1052L11.6185 30.9992H16.3825L18.9355 36.1062ZM20.3465 24.6562L16.5465 28.9992H11.4545L7.65445 24.6562C6.70945 23.5752 6.01045 22.3232 5.56645 20.9842C6.08145 21.0322 6.59745 20.8792 6.98145 20.5312C7.34445 20.8392 7.79445 20.9982 8.25245 20.9982C8.50745 20.9982 8.76445 20.9492 9.00945 20.8482C9.69445 20.5642 10.1575 19.9292 10.1925 19.2172C10.9305 19.1562 11.5655 18.6932 11.8495 18.0082C12.0115 17.6172 12.0265 17.2012 11.9335 16.8142C11.9545 16.8232 11.9705 16.8392 11.9915 16.8482C12.6775 17.1322 13.4525 17.0102 13.9815 16.5322C14.3445 16.8402 14.7945 16.9992 15.2525 16.9992C15.5075 16.9992 15.7645 16.9502 16.0095 16.8492C16.0295 16.8412 16.0455 16.8262 16.0645 16.8172C15.9745 17.2092 15.9915 17.6222 16.1515 18.0102C16.4355 18.6952 17.0705 19.1582 17.7825 19.1932C17.8435 19.9312 18.3065 20.5662 18.9915 20.8502C19.6765 21.1332 20.4525 21.0132 20.9815 20.5342C21.3445 20.8422 21.7945 21.0012 22.2525 21.0012C22.3135 21.0012 22.3745 20.9892 22.4355 20.9832C21.9925 22.3212 21.2925 23.5742 20.3465 24.6562ZM26.0055 10.2702C25.0635 10.3022 24.3055 11.0602 24.2255 12.0242C24.0845 11.8932 23.9255 11.7952 23.7595 11.7172C23.5595 11.4772 23.3105 11.2752 23.0085 11.1502C22.5075 10.9432 21.9585 10.9552 21.4775 11.1622C21.1745 10.6422 20.6245 10.2762 19.9735 10.2222C20.1285 10.0562 20.2365 9.86619 20.3165 9.66619C20.8235 9.33819 21.1625 8.81119 21.1905 8.21619C21.9285 8.15519 22.5635 7.69219 22.8475 7.00719C22.9255 6.81819 22.9665 6.62119 22.9835 6.42519C23.4405 6.43819 23.8975 6.30919 24.2715 5.99219C24.3035 6.93419 25.0615 7.69219 26.0255 7.77219C25.3815 8.46319 25.3815 9.53319 26.0055 10.2702Z"
          fill="#FEFBE9"
        />
      </svg>
    </i>
  );
};
export const Map = (props) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4998 18.75L7.74201 12.0312C6.96325 11.1118 6.46173 9.98996 6.29588 8.79648C6.13003 7.60299 6.30667 6.38694 6.80522 5.28996C7.30377 4.19299 8.10372 3.26022 9.1119 2.60031C10.1201 1.94039 11.295 1.58048 12.4998 1.5625C14.1699 1.579 15.7654 2.25671 16.9369 3.4472C18.1083 4.63768 18.7602 6.2439 18.7498 7.91406C18.7505 9.37104 18.2544 10.7847 17.3436 11.9219L12.4998 18.75ZM12.4998 3.125C11.2435 3.13943 10.0442 3.65186 9.1653 4.54977C8.28643 5.44768 7.79982 6.65768 7.81233 7.91406C7.81756 9.0608 8.23012 10.1684 8.97639 11.0391L12.4998 16.0312L16.117 10.9375C16.8046 10.0793 17.1818 9.01375 17.1873 7.91406C17.1998 6.65768 16.7132 5.44768 15.8343 4.54977C14.9555 3.65186 13.7562 3.13943 12.4998 3.125Z"
        fill="#F0A04B"
      />
      <path
        d="M12.5 8.59375C13.3629 8.59375 14.0625 7.8942 14.0625 7.03125C14.0625 6.16831 13.3629 5.46875 12.5 5.46875C11.6371 5.46875 10.9375 6.16831 10.9375 7.03125C10.9375 7.8942 11.6371 8.59375 12.5 8.59375Z"
        fill="#F0A04B"
      />
      <path
        d="M21.875 9.375H20.3125V10.9375H21.875V21.875H3.125V10.9375H4.6875V9.375H3.125C2.7106 9.375 2.31317 9.53962 2.02015 9.83265C1.72712 10.1257 1.5625 10.5231 1.5625 10.9375V21.875C1.5625 22.2894 1.72712 22.6868 2.02015 22.9799C2.31317 23.2729 2.7106 23.4375 3.125 23.4375H21.875C22.2894 23.4375 22.6868 23.2729 22.9799 22.9799C23.2729 22.6868 23.4375 22.2894 23.4375 21.875V10.9375C23.4375 10.5231 23.2729 10.1257 22.9799 9.83265C22.6868 9.53962 22.2894 9.375 21.875 9.375Z"
        fill="#F0A04B"
      />
    </svg>
  );
};

export function PepiconsPencilMap(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      {...props}
    >
      <g fill="currentColor">
        <path
          fillRule="evenodd"
          d="M10 8.5a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0-3a1 1 0 1 1 0 2a1 1 0 0 1 0-2"
          clipRule="evenodd"
        ></path>
        <path
          fillRule="evenodd"
          d="M5.5 6.286C5.5 8.959 8.153 13.5 10 13.5c1.848 0 4.5-4.541 4.5-7.214C14.5 3.65 12.493 1.5 10 1.5S5.5 3.65 5.5 6.286m8 0c0 2.193-2.348 6.214-3.5 6.214c-1.151 0-3.5-4.02-3.5-6.214C6.5 4.187 8.075 2.5 10 2.5s3.5 1.687 3.5 3.786"
          clipRule="evenodd"
        ></path>
        <path d="M13.435 9.14a.5.5 0 0 1 .369-.929a3 3 0 0 1 1.74 1.84l1.334 4A3 3 0 0 1 14.03 18H5.97a3 3 0 0 1-2.846-3.949l1.333-4A3 3 0 0 1 6.24 8.194a.5.5 0 1 1 .355.935a2 2 0 0 0-1.19 1.239l-1.333 4A2 2 0 0 0 5.97 17h8.062a2 2 0 0 0 1.897-2.633l-1.332-4a2 2 0 0 0-1.16-1.226"></path>
      </g>
    </svg>
  );
}

export function IcRoundSwipeUp(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.83 19.1c-.26-.6.09-1.28.73-1.41l3.58-.71l-4.35-9.81c-.34-.76 0-1.64.76-1.98s1.64 0 1.98.76l2.43 5.49l.84-.37c.28-.13.59-.18.9-.17l4.56.21a2 2 0 0 1 1.83 1.45l1.23 4.33c.27.96-.2 1.97-1.11 2.37l-5.63 2.49c-.48.21-1.26.33-1.76.14l-5.45-2.27a.95.95 0 0 1-.54-.52m-2.08-5.72c.26-.26.29-.66.09-.95a10.44 10.44 0 0 1-1.52-8.49l1.09 1.09c.3.3.79.29 1.08-.02c.28-.3.25-.78-.04-1.07L5.21 1.71a.996.996 0 0 0-1.41 0L1.53 3.97c-.3.3-.29.79.02 1.08c.3.28.78.25 1.07-.04L3.8 3.82c-.2.86-.3 1.76-.3 2.68c0 2.51.77 4.85 2.09 6.77c.27.39.82.45 1.16.11"
      ></path>
    </svg>
  );
}

export function IcRoundSend(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="m3.4 20.4l17.45-7.48a1 1 0 0 0 0-1.84L3.4 3.6a.993.993 0 0 0-1.39.91L2 9.12c0 .5.37.93.87.99L17 12L2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91"
      ></path>
    </svg>
  );
}
